import type { UserRole } from "../types/vtc";
import { api } from "./api";

export interface ReviewRow {
  id: string;
  status: "pending" | "published" | "rejected";
  rating: number;
  text: string;
  /** Who/what the review is about, and who wrote it ("Nadia H." / company name). */
  about: string;
  by: string;
  vehicle: string;
  bookingRef: string;
  rentalStart: string | null;
  rentalEnd: string | null;
  createdAt: string;
  updatedAt: string;
}

export interface ToReview {
  bookingId: string;
  ref: string;
  about: string;
  vehicle: string;
  start: string;
  end: string;
}

export interface MyReviews {
  /** Published reviews about the account; average null when none. */
  rating: { average: number | null; count: number };
  written: ReviewRow[];
  received: ReviewRow[];
  toWrite: ToReview[];
}

/** GET /{driver|company}/reviews */
export async function getMyReviews(role: UserRole): Promise<MyReviews> {
  const { data } = await api.get<MyReviews>(`/${role}/reviews`);
  return data;
}

/** POST /{driver|company}/reviews — about a completed booking; pending until approved. */
export async function writeReview(role: UserRole, bookingId: string, rating: number, text: string): Promise<string> {
  const { data } = await api.post<{ message: string }>(`/${role}/reviews`, { bookingId, rating, text });
  return data.message;
}

/** PATCH /{driver|company}/reviews/:id — the review goes back to "pending". */
export async function editReview(role: UserRole, id: string, rating: number, text: string): Promise<string> {
  const { data } = await api.patch<{ message: string }>(`/${role}/reviews/${encodeURIComponent(id)}`, { rating, text });
  return data.message;
}

/** DELETE /{driver|company}/reviews/:id */
export async function deleteReview(role: UserRole, id: string): Promise<string> {
  const { data } = await api.delete<{ message: string }>(`/${role}/reviews/${encodeURIComponent(id)}`);
  return data.message;
}
